import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ReactComponent as GroupIconSvg } from './Resources/group.svg'
import { ReactComponent as OvalIconSvg } from './Resources/oval.svg'

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    marginLeft: '0px',
    marginRight: '2rem',
    minHeight: '4rem',
    fontSize: '1.4rem',
    color: '#767676',
    '&:focus-within': {
        color: '#000000',
    },
}))

const StyledRadio = styled(Radio)(({ theme }) => ({
    padding: 0,
    margin: 0,
    paddingRight: '1.2rem',
    '&:hover': {
        backgroundColor: 'transparent !important',
    },
}))

function CustomRadio(props) {
    return (
        <StyledRadio
            disableRipple
            color="default"
            checkedIcon={
                <Box display="flex" alignItems="center">
                    <GroupIconSvg />
                </Box>
            }
            icon={<OvalIconSvg />}
            {...props}
        />
    )
}

const RadioList = ({ props, handleChange, value, data }) => {
    return (
        data.options && (
            <FormControl variant="standard" component="fieldset">
                <FormLabel
                    component="legend"
                    sx={{
                        fontSize: '1.8rem',
                        fontWeight: 'bold',
                        color: '#000000',
                    }}
                >
                    {data.heading}
                </FormLabel>
                <RadioGroup
                    defaultValue="100"
                    aria-label="100"
                    name="customized-radios"
                    value={value}
                    onChange={handleChange}
                    row
                >
                    {data.options.map((option, index) => (
                        <StyledFormControlLabel
                            key={option.id}
                            value={option.id}
                            control={<CustomRadio />}
                            label={option.friendlyName}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        )
    )
}

RadioList.propTypes = {
    handleChange: PropTypes.func,
    value: PropTypes.string,
    data: PropTypes.object,
}

export default RadioList
